<template>
  <b-container class="text-center mt-5">
    <b-card class="mx-auto" style="max-width: 400px">
      <div v-if="loading">
        <b-spinner></b-spinner>
        <p class="mt-3">Vérification en cours...</p>
      </div>

      <div v-else-if="error">
        <b-alert variant="danger" show>
          <h5>Erreur de connexion</h5>
          <p>{{ error }}</p>
        </b-alert>
        <b-button variant="primary" @click="goToLogin">
          Retour à la page de connexion
        </b-button>
      </div>

      <div v-else-if="success">
        <b-alert variant="success" show>
          <h5>Connexion réussie !</h5>
          <p>Redirection en cours...</p>
        </b-alert>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import ApiService from "@/service/apiService";
import AuthService from "@/service/authService";

export default {
  name: "Verify",
  data() {
    return {
      loading: true,
      success: false,
      error: null,
    };
  },
  async mounted() {
    const token = this.$route.query.token;

    if (!token) {
      this.error = "Token manquant";
      this.loading = false;
      return;
    }

    try {
      const response = await ApiService.auth.verify(token);
      if (response.data.success) {
        this.success = true;
        // Rafraîchir l'utilisateur dans le service d'auth
        await AuthService.fetchUser();
        // Rediriger vers l'accueil
        setTimeout(() => {
          this.$router.push({ name: "Accueil" });
        }, 1000);
      } else {
        this.error = response.data.error || "Erreur de vérification";
      }
    } catch (err) {
      this.error =
        err.response?.data?.error || "Erreur lors de la vérification du token";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style scoped></style>
